module.exports = __webpack_public_path__ + "static/cff510.jpg";